module.exports = __webpack_public_path__ + "img/laser.63b077e5.png";